import {Order, Task, TaskExecuteAction,  TaskState} from "@/types";
import {executeTask} from "@/store/services/task/workflow";
import {deepClone} from "@/utils";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/i18n";

export async function executeCancelationRequest(taskState: TaskState, order: Order, task: Task, cancelationRequestComment: any) {
    // TODO verify if need to save the decision on the database
    const taskExecuteAction: TaskExecuteAction = {
        taskId: task.taskId || '',
        variables: {
            cancellation: {
                type: "Boolean",
                value: true
              },
            cancellationRequestComment: {
                type: "String",
                value: cancelationRequestComment
              }
        }
    }
    try {
        const result = await executeTask(taskExecuteAction);
        Notify.create({
            message: i18n.global.t('task.executed'),
            color: 'positive'
        });
        return result;
    } catch (e) {
        console.error(e)
        return Promise.reject(e)
    }
}
